import React from 'react';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useAuth } from '~/context/auth';
import useAppLocale from '~/data/hooks/useAppLocale';
import { RootStackParamList } from '~/navigation/types';
import SignUpSuccessLayout from './layout';

type SignUpSuccessNavProp = StackNavigationProp<
  RootStackParamList,
  'SignUpSuccess'
>;

export default function SignUpSuccess(): JSX.Element {
  const navigation = useNavigation<SignUpSuccessNavProp>();

  const { authUser, onLogout, rootEntranceKey } = useAuth();

  const firstName = authUser?.firstName || '';

  const { locale, onChangeLocale } = useAppLocale({
    onReload: () => navigation.replace('SignUpSuccess'),
  });

  const onJoinLaterWeb = async () => {
    onLogout();
    navigation.reset({
      routes: [{ name: rootEntranceKey }],
    });
  };
  const onLoginWeb = async () => {
    await onLogout();
    navigation.reset({
      routes: [
        {
          name: 'AuthStack',
          params: {
            screen: 'Launch',
            params: {
              lang: locale,
            },
          },
        },
        {
          name: 'AuthStack',
          params: {
            screen: 'Login',
            params: {
              lang: locale,
            },
          },
        },
      ],
    });
  };

  return (
    <SignUpSuccessLayout
      name={firstName}
      selectedLocale={locale}
      onJoinNow={() => {
        navigation.goBack();
        navigation.navigate('GroupStack', {
          screen: 'JoinSelectLocation',
        });
      }}
      onJoinLater={() => {
        navigation.goBack();
      }}
      onJoinLaterWeb={onJoinLaterWeb}
      onLoginWeb={onLoginWeb}
      onLogout={() => {
        navigation.goBack();
        onLogout();
      }}
      onSelectedLocale={onChangeLocale}
    />
  );
}
